
export default {
    HEBREW_LANGUAGE: 'Hebrew',
    ENGLISH_LANGUAGE: 'English',
    TEXT_DIRECTION_RTL: 'rtl',
    errors: {
        USER_NOT_LOGGED_IN: 'User Not Logged In',
        INVALID_FILE_UPLOAD: 'Invalid File',
        INVALID_PASSWORD: 'Invalid Password',
        INVALID_EMAIL: 'Invalid Email',
    },
    PDF_FILE_MIME_TYPE: 'application/pdf',
    MSWORD_DOC_FILE_MIME_TYPE: 'application/msword',
    MSWORD_DOCX_FILE_MIME_TYPE: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    MAXIMUM_FILE_SIZE_IN_BYTES: 5000000,
    MINIMUM_PASSWORD_LENGTH: 6,
};